/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

/**
 * State
 *
 * @type {Object}
 */
const base = {
    data: {
        date: null,
        file_name: null,
        input: {
            data: {},
            meta: {}
        },
        output: {
            noi: [],
            meta: {},
            excluded: []
        },
        meta: {}
    },
    errors: {
        message: null,
        sheet_names: [],
        opex_file_id: null,
        error_type: null,
        attempted_sheet_name: null
    },
    showInputBindings: true,
    requestingHelp: false,
    helpRequested: false,
    loading: false,
    uploaded: false,
    pnl_file_id: null,
    assistanceMessage: null,
    activeTab: 'opex',
    selectedCategory: '',
    searchTerm: '',
    selectedColorIndex: null,
    success: false,
    colors: {
        opaque: [
            'rgba(204, 153, 102, 1)',
            'rgba(255, 102, 204, 1)',
            'rgba(102, 204, 153, 1)',
            'rgba(255, 204, 102, 1)',
            'rgba(204, 153, 204, 1)',
            'rgba(255, 102, 51, 1)',
            'rgba(102, 153, 51, 1)',
            'rgba(102, 153, 255, 1)',
            'rgba(153, 204, 255, 1)',
            'rgba(255, 195, 0, 1)',
            'rgba(153, 0, 204, 1)',
            'rgba(102, 51, 51, 1)'
        ],
        translucent: [
            'rgba(204, 153, 102, 0.2)',
            'rgba(255, 102, 204, 0.2)',
            'rgba(102, 204, 153, 0.2)',
            'rgba(255, 204, 102, 0.2)',
            'rgba(204, 153, 204, 0.2)',
            'rgba(255, 102, 51, 0.2)',
            'rgba(102, 153, 51, 0.2)',
            'rgba(102, 153, 255, 0.2)',
            'rgba(153, 204, 255, 0.2)',
            'rgba(255, 195, 0, 0.2)',
            'rgba(153, 0, 204, 0.2)',
            'rgba(102, 51, 51, 0.2)'
        ]
    }
}

/**
 * Return a fresh copy of the base state
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(base)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/pnl-importer/state.js